<template>
  <BaseIcon
    :width="width"
    :height="height"
    box="0 0 16 16"
    :color="color"
    title="Icon Filter"
    style="padding: 1px"
  >
    <!-- eslint-disable max-len -->
    <path
      d="M4.6702 4.0013H11.3369L7.99687 8.2013L4.6702 4.0013ZM2.83687 3.7413C4.18354 5.46797 6.6702 8.66797 6.6702 8.66797V12.668C6.6702 13.0346 6.9702 13.3346 7.33687 13.3346H8.6702C9.03687 13.3346 9.33687 13.0346 9.33687 12.668V8.66797C9.33687 8.66797 11.8169 5.46797 13.1635 3.7413C13.5035 3.3013 13.1902 2.66797 12.6369 2.66797H3.36354C2.8102 2.66797 2.49687 3.3013 2.83687 3.7413Z"
    />
  </BaseIcon>
</template>

<script>
import BaseIcon from './BaseIcon.vue';

export default {
  components: {
    BaseIcon,
  },
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
    width: {
      type: [Number, String],
      default: 20,
    },
    height: {
      type: [Number, String],
      default: 20,
    },
  },
};
</script>
